import { Box } from '@mui/material';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import ReponsiveModal from '../Common/CustomModal';
import ApplicationViewModal from './ApplicationViewModal';
import { ICoachRow } from './Columns';
import { CoachStatus } from '../../types/coach';
import { approveCoachRequest, rejectCoachRequest } from '../../redux/coach/coachSlice';

interface IRowActionsProps {
  row: ICoachRow;
  action: string;
}

function ViewAction({ row, action }: IRowActionsProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch();

  const handleApprove = () => {
    setIsModalOpen(false);
    dispatch(approveCoachRequest({ coachId: row.id }));
  };

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleReject = () => {
    setIsModalOpen(false);
    dispatch(rejectCoachRequest({ coachId: row.id }));
  };

  if (row.status === CoachStatus.APPROVED || row.status === CoachStatus.REJECTED) {
    return null;
  }

  return (
    <Box display="flex" justifyContent="center">
      {action === 'view' && (
        <img
          src="/assets/icons/eye-bold.svg"
          alt="action"
          onClick={handleOpenModal}
          role="presentation"
          style={{ cursor: 'pointer' }}
        />
      )}
      {action === 'approve' && (
        <img
          src="/assets/icons/check-circle-bold.svg"
          alt="action"
          onClick={handleApprove}
          role="presentation"
          style={{ cursor: 'pointer' }}
        />
      )}
      {action === 'reject' && (
        <img
          src="/assets/icons/close-circle-bold.svg"
          alt="action"
          onClick={handleReject}
          role="presentation"
          style={{ cursor: 'pointer' }}
        />
      )}
      {isModalOpen && (
        <ReponsiveModal isOpen={isModalOpen} onClose={handleCloseModal} xs={3}>
          <ApplicationViewModal
            handleDismiss={handleCloseModal}
            username={`${row.firstName} ${row.lastName}`}
            email={row.email}
            profilePicture={row.profilePicture}
            phone={row.tp}
            handleAccept={handleApprove}
            handleReject={handleReject}
          />
        </ReponsiveModal>
      )}
    </Box>
  );
}

export default ViewAction;
